import { render, staticRenderFns } from "./ttfopenaccount-add-or-update.vue?vue&type=template&id=f6d4a13c&scoped=true&"
import script from "./ttfopenaccount-add-or-update.vue?vue&type=script&lang=js&"
export * from "./ttfopenaccount-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./ttfopenaccount-add-or-update.vue?vue&type=style&index=0&id=f6d4a13c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d4a13c",
  null
  
)

export default component.exports